export const BACKUP_LEDGER_KEY = 'mon-testament-last-backup';

/**
 * The day of the last backup, kept on the phone in clear: a date, and nothing about the will. A
 * storage that refuses — private browsing, blocked site data — leaves the screen saying "never",
 * which is the honest thing to say when it cannot know.
 */
export class BackupLedger {
  constructor(private readonly storage: Pick<Storage, 'getItem' | 'setItem'> | undefined) {}

  lastBackupAt(): string | null {
    try {
      return this.storage?.getItem(BACKUP_LEDGER_KEY) ?? null;
    } catch {
      return null;
    }
  }

  recordBackup(at: string): void {
    try {
      this.storage?.setItem(BACKUP_LEDGER_KEY, at);
    } catch {
      // Nothing to do: the backup itself has been made, only its date is not remembered.
    }
  }
}
